import dayjs from 'dayjs';
import { DATE_FORMAT } from '../components/Forms/DatePicker';

function getClosestDateItemFromToday({
  dates,
  showDefaultDate = true,
  enablePastDates = false,
}) {
  const defaultDateItem = {
    requestDate: dayjs().add(1, 'day').format(DATE_FORMAT.STANDARD_DATE),
  };
  if (Array.isArray(dates) && dates.length > 0) {
    const todayDateItem = dates.find(
      d =>
        d?.requestDate && dayjs(d.requestDate).isSame(dayjs().startOf('day')),
    );
    if (todayDateItem) {
      return todayDateItem;
    }

    const futureDates = dates.filter(d =>
      dayjs(d?.requestDate).isAfter(dayjs()),
    );
    if (futureDates.length === 0) {
      if (enablePastDates) {
        return dates
          .filter(d => d?.requestDate)
          .reduce((closest, current) =>
            dayjs(current.requestDate).isAfter(dayjs(closest.requestDate))
              ? current
              : closest,
          );
      }
      return showDefaultDate ? defaultDateItem : 'None Specified';
    }

    return futureDates.reduce((closest, current) =>
      dayjs(current.requestDate).isBefore(dayjs(closest.requestDate))
        ? current
        : closest,
    );
  }
  return showDefaultDate ? defaultDateItem : 'None Specified';
}

export default getClosestDateItemFromToday;
